import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Actions/ic_fields");
function FieldsIcon(_ref) {
  let {
      color = '#788590'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M19.619 11.524H18.19v-3.81a1.904 1.904 0 00-1.904-1.904h-3.81V4.38a2.381 2.381 0 00-4.762 0V5.81h-3.81A1.905 1.905 0 002 7.714v3.62h1.429A2.56 2.56 0 016 13.903a2.56 2.56 0 01-2.571 2.572H2v3.62C2 21.146 2.853 22 3.905 22h3.619v-1.429A2.56 2.56 0 0110.095 18a2.56 2.56 0 012.572 2.571V22h3.619a1.905 1.905 0 001.904-1.905v-3.81h1.429a2.381 2.381 0 000-4.761z",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default /*#__PURE__*/memo(FieldsIcon);